import React from 'react';
import { motion } from 'framer-motion';
import { Scale, AlertCircle, TrendingDown } from 'lucide-react';
export function CostTable() {
  const rows = [{
    without: 'Comprar día a día en el almacén',
    cost: '+40% más caro'
  }, {
    without: 'Improvisar sin lista',
    cost: '+23% de gasto invisible'
  }, {
    without: 'Tirar comida',
    cost: '30-40% de lo que comprás'
  }, {
    without: 'Delivery por cansancio',
    cost: '$5.000-$15.000 por noche'
  }, {
    without: 'Desayunos y viandas afuera',
    cost: 'Hasta $60.000 anuales'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-55">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-56">
        <div className="text-center mb-10" data-id="element-57">
          <div className="inline-flex items-center justify-center p-3 bg-navy-800 rounded-full mb-4 border border-navy-600" data-id="element-58">
            <Scale className="w-8 h-8 text-gold-400" data-id="element-59" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-60">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-hidden rounded-2xl border border-red-900/30 bg-navy-900/80 shadow-2xl" data-id="element-61">
          <table className="w-full text-left border-collapse" data-id="element-62">
            <thead data-id="element-63">
              <tr data-id="element-64">
                <th className="p-4 md:p-6 border-b border-navy-700 bg-navy-800 text-gray-300 font-semibold w-1/2" data-id="element-65">
                  <div className="flex items-center gap-2" data-id="element-66">
                    <AlertCircle className="w-4 h-4 text-gray-400" data-id="element-67" />
                    Sin MegaPack
                  </div>
                </th>
                <th className="p-4 md:p-6 border-b border-red-900/50 bg-red-950/20 text-red-300 font-bold w-1/2" data-id="element-68">
                  <div className="flex items-center gap-2" data-id="element-69">
                    <TrendingDown className="w-4 h-4 text-red-400" data-id="element-70" />
                    El costo real
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-71">
              {rows.map((row, index) => <tr key={index} className="border-b border-navy-800 last:border-0" data-id="element-72">
                  <td className="p-4 md:p-6 text-blue-100/70" data-id="element-73">{row.without}</td>
                  <td className="p-4 md:p-6 text-red-200/90 font-medium bg-red-950/10" data-id="element-74">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </section>;
}